// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2-uNh","buttons":"PendingPaymentAlert_buttons__1aggH"};